import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

interface UtmSettings {
  utmCampaign: string | null;
  utmMedium: string | null;
  utmSource: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class UtmParamsGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.handleUtmParams(route);
    return true;
  }

  private handleUtmParams(route: ActivatedRouteSnapshot): void {
    const paramMap = route.queryParamMap;

    // Handle UTM parameters
    const utmSettings: UtmSettings = {
      utmCampaign: paramMap.get('utm_campaign'),
      utmMedium: paramMap.get('utm_medium'),
      utmSource: paramMap.get('utm_source'),
    };

    localStorage.setItem('utmSettings', JSON.stringify(utmSettings));

    // Handle referrer
    const referrer = paramMap.get('referrer');
    if (referrer) {
      localStorage.setItem('referrer', referrer);
    }

    // Handle UUID referrer
    const uuidRefer = paramMap.get('uuidRefer');
    if (uuidRefer) {
      localStorage.setItem('uuidRefer', uuidRefer);
    }

    // Handle reserved shortid
    const reservedShortid = paramMap.get('reservedShortid');
    if (reservedShortid) {
      localStorage.setItem('reservedShortid', reservedShortid);
    }
  }
}
